export default "__VITE_ASSET__CKvex5tB__"